import React, { useRef } from 'react'
import moment from 'moment'
import HTML5Backend, { NativeTypes } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import { Text, Droppable } from '@components/UI'

import Section from './Section'
import Upload from '../../../Upload'

const Files = (props) => {
  const { data, loading } = props
  const months = moment.months().reverse()
  const container = useRef(null)
  const onDrop = (item, monitor) => {
    if (monitor) {
      const files = monitor.getItem().files
      props.upload(files)
    }
  }

  const { today, yesterday, week, month, year, sometime } = data
  const empty = !(today || yesterday || week || month || year || sometime)

  return (
    <DndProvider backend={HTML5Backend}>
      <Droppable
        ref={(elem) => (container.current = elem)}
        item={{ type: NativeTypes.FILE }}
        onDrop={onDrop}
        style={{ width: '100%', height: '100%' }}
      >
        {(isOver) => {
          return (
            <div className={'gp-finder-files'}>
              {isOver && <Upload />}
              {empty && !loading ? (
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Text className='color-f' style={{ opacity: 0.35 }}>
                    No files found
                  </Text>
                </div>
              ) : (
                <React.Fragment>
                  {today && (
                    <Section
                      title='Today'
                      data={today}
                      loadFile={props.loadFile}
                      theme={props.theme}
                    />
                  )}
                  {yesterday && (
                    <Section
                      title='Yesterday'
                      data={yesterday}
                      loadFile={props.loadFile}
                      theme={props.theme}
                    />
                  )}
                  {week && (
                    <Section
                      title='Previous Week'
                      data={week}
                      loadFile={props.loadFile}
                      theme={props.theme}
                    />
                  )}
                  {month && (
                    <Section
                      title='Previous Month'
                      data={month}
                      loadFile={props.loadFile}
                      theme={props.theme}
                    />
                  )}
                  {year &&
                    year
                      .slice()
                      .reverse()
                      .map((v, i) =>
                        v.length ? (
                          <Section
                            title={months[i]}
                            data={v}
                            key={months[i].toLowerCase()}
                            loadFile={props.loadFile}
                            theme={props.theme}
                          />
                        ) : null
                      )}
                  {sometime &&
                    Object.keys(sometime)
                      .sort((a, b) => (b > a ? 1 : -1))
                      .map((v) => (
                        <Section
                          title={v}
                          data={sometime[v]}
                          key={`${v}`}
                          loadFile={props.loadFile}
                          theme={props.theme}
                        />
                      ))}
                </React.Fragment>
              )}
            </div>
          )
        }}
      </Droppable>
    </DndProvider>
  )
}

export default Files
